<template>
    <div class="new-task">
        <Breadcrumb />
        <h1>新增委託</h1>
        <new-task-comp></new-task-comp>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import NewTaskComp from '@/components/landlord/taskManagement/NewTaskComp.vue';

export default {
    created() {
        this.$store.dispatch('sendEventLog', 'CREATE_TASK')  
    },
    components: {
        Breadcrumb,
        NewTaskComp
    }
}
</script>
<style lang="scss" scoped>
    .new-task{
        position: relative;
        margin-top: 82px;
        > h1{
            margin-top: 26px;
            margin-bottom: 40px;
            font-size: 28px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/TaskManagementPages/NewTask.vue